// allows you to set classnames conditionally
export default function classNames(...args: any[]): string {
    return [...parseValue(args)].join(' ');
}

function parseValue(arg: any, classes: Set<string> = new Set<string>()): Set<string> {
    // Handle null and undefined explicitly
    if (arg === null || arg === undefined) {
        return classes;
    }

    if (typeof arg === 'string') {
        // Only add non-empty strings
        if (arg) {
            classes.add(arg);
        }
        return classes;
    }

    if (typeof arg !== 'object') {
        // Handle other non-object falsy values (false, 0, etc.)
        return classes;
    }

    if (Array.isArray(arg)) {
        for (const item of arg) {
            classes = parseValue(item, classes);
        }
        return classes;
    }

    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        classes.add(arg.toString());
        return classes;
    }

    for (const key of Object.keys(arg)) {
        if (arg[key]) {
            classes.add(key);
        }
    }

    return classes;
}
